<template>
  <router-view />
</template>
<script setup></script>
<style lang="scss">
@import url('./style/common.css');
</style>
